import {
  MediaAnalysisProgress,
  MediaAnalysisStatus,
  MediaAnalysisType
} from '@/common/model/media/mediaAnalysis'

export const MediaAnalysisApiPath = {
  LIST_ANALYSIS_TYPES: '/api/sites/{site_id}/media-analysis/types', // GET List Analysis Types
  LIST_ANALYSIS_HISTORY: '/api/sites/{site_id}/media-analysis/history', // GET List Analysis History
  GET_ANALYSIS_HISTORY_DETAIL: '/api/sites/{site_id}/media-analysis/history/{history_id}' // GET Get Analysis History Detail
}

export type MediaAnalysisApiPath = (typeof MediaAnalysisApiPath)[keyof typeof MediaAnalysisApiPath]

export interface ListAnalysisTypesVars {
  site_id: number
}

export interface ListAnalysisHistoryVars {
  site_id: number
  analysis_type?: string | null
  q?: string | null
  date_from?: string | null
  date_to?: string | null
  execution_source?: string | null
  // 実行状態（analyzing / completed / failed）での絞り込み
  status?: MediaAnalysisStatus | null
  page?: number
  per_page?: number
}

export interface GetAnalysisHistoryDetailVars {
  site_id: number
  history_id: number
}

export interface AnalysisTypeDef {
  key: MediaAnalysisType
  label: string
  description: string
  requires_target: boolean
  is_geo_llmo: boolean
  enabled: boolean
}

export type ListAnalysisTypesResponse = AnalysisTypeDef[]

export interface AnalysisHistoryListItem {
  id: number
  analysis_type: MediaAnalysisType
  analysis_type_label: string
  summary: string
  execution_source: string
  created_at: string | null
  generated_action_count: number
  status: MediaAnalysisStatus
}

export interface ListAnalysisHistoryResponse {
  total: number
  items: AnalysisHistoryListItem[]
}

export interface GetAnalysisHistoryDetailResponse {
  id: number
  site_id: number
  analysis_type: string
  analysis_type_label: string
  input_data: Record<string, unknown>
  result_data: Record<string, unknown>
  summary: string
  execution_source: string
  status?: MediaAnalysisStatus
  progress?: MediaAnalysisProgress
  created_at: string | null
}
